import React from 'react';
import { useDispatch } from 'react-redux';
import './SpecialOfTheDay.css';
import { addProduct } from '../Actions';
import { v4 as uuid } from 'uuid';

function SpecialOfTheDay() {
    const dispatch = useDispatch();

    return (
        <div className='day-container'>
            <h1>Pasta of the day</h1>
            <p>Italian tagliatelle with porcini mushrooms</p>
            <button
                onClick={() =>
                    dispatch(
                        addProduct({
                            name: 'Tagliatelle with porcini mushrooms',
                            price: 14.99,
                            index: uuid(),
                        })
                    )
                }
            >
                Order now
            </button>
        </div>
    );
}

export default SpecialOfTheDay;
